import { render, staticRenderFns } from "./BCOptionalFeatureBluetooth.vue?vue&type=template&id=08f43081"
import script from "./BCOptionalFeatureBluetooth.vue?vue&type=script&lang=js"
export * from "./BCOptionalFeatureBluetooth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports